import SectionHeader from "components/Common/SectionHeader"
import React from "react"
import { Card, CardBody } from "reactstrap"
import StockDescriptionUpdate from "./StockDescriptionUpdate"
import ThemePlaceholder from "components/Common/ThemePlaceholder"

export default function Description({ stock, loading = false }) {
  const renderContent = (text, lines = 3) => {
    if (loading) {
      return (
        <div className="d-flex flex-column gap-2 p-3 bg-light rounded">
          {Array.from({ length: lines }).map((_, idx) => (
            <ThemePlaceholder key={idx} style={{ width: "100%", height: 10, borderRadius: 4 }} />
          ))}
        </div>
      )
    }
    return (
      <p className="text-muted mb-0 p-3 bg-light rounded">
        {text || "No description available."}
      </p>
    )
  }

  return (
    <Card className="border-0 shadow-sm mb-0">
      <CardBody className="p-3">
        <SectionHeader
          icon="bx bx-note"
          title="Description"
          action={loading ? null : <StockDescriptionUpdate stock={stock} />}
        />
        <div>
          <div className="mb-3">
            <h6 className="fw-semibold mb-2">Short Description</h6>
            {renderContent(stock?.short_descriptions, 3)}
          </div>
          <div>
            <h6 className="fw-semibold mb-2">Full Description</h6>
            {renderContent(stock?.full_descriptions, 5)}
          </div>
        </div>
      </CardBody>
    </Card>
  )
}
